
import Vue from "vue";

import BlankSpace from "@/components/BlankSpace.vue";

export default Vue.extend({
  name: "TableCustom",
  components: { BlankSpace },
  props: {
    headers: {
      type: Array,
      required: true,
      default: () => [],
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    itemKey: {
      type: String,
      required: false,
      default: "id",
    },
    showSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    showPagination: {
      type: Boolean,
      required: false,
      default: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemsPerPageOptions: {
      type: Array as () => number[],
      required: false,
      default: null,
    },
    defaultItemsPerPage: {
      type: Number,
      required: false,
      default: 10,
    },
    // total row count when the parent pages on the server; -1 keeps client-side paging
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1,
    },
  },
  data() {
    const itemsPerPageData: { label: string; value: number }[] = this.itemsPerPageOptions
      ? this.itemsPerPageOptions.map((n: number) => ({ label: String(n), value: n }))
      : [
          { label: "5", value: 5 },
          { label: "10", value: 10 },
          { label: "15", value: 15 },
          { label: "All", value: -1 },
        ];

    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: this.showPagination ? this.defaultItemsPerPage : -1,
      itemsPerPageData,
    };
  },
  computed: {
    hasWidePageSize(): boolean {
      return this.itemsPerPageData.some((option: { value: number }) => option.value >= 100);
    },
    pagination(): { page: number; itemsPerPage: number } {
      return { page: this.page, itemsPerPage: this.itemsPerPage };
    },
  },
  watch: {
    // one event per tick, even when a page-size change also resets the page
    pagination(value: { page: number; itemsPerPage: number }) {
      this.$emit("pagination-change", value);
    },
  },
  methods: {
    resetPage() {
      this.page = 1;
    },
    setPage(page: number) {
      this.page = page;
    },
    changePerPage(num: number) {
      this.itemsPerPage = num;
      this.page = 1;
    },
    toggleSelectAll(props: { items: any[]; value: boolean }) {
      this.$emit("selectAll", props);
    },
  },
});
